import makeActionCreator from './makeActionCreator';
import trivialArgsMapper from './_trivialArgsMapper';
import { getOptions } from './utils';
export var ACTION_ASYNC_REQUEST_SUFFIX = '@ASYNC_REQUEST';
export var ACTION_ASYNC_SUCCESS_SUFFIX = '@ASYNC_SUCCESS';
export var ACTION_ASYNC_FAILURE_SUFFIX = '@ASYNC_FAILURE';
export var ACTION_ASYNC_PROGRESS_SUFFIX = '@ASYNC_PROGRESS';
export var ACTION_ASYNC_CANCEL_SUFFIX = '@ASYNC_CANCEL';
export var ACTION_ASYNC_SUCCESS_METHOD = 'success';
export var ACTION_ASYNC_FAILURE_METHOD = 'failure';
export var ACTION_ASYNC_PROGRESS_METHOD = 'progress';
export var ACTION_ASYNC_CANCEL_METHOD = 'cancel';
/**
 * @typedef {ActionCreator} AsyncActionCreator
 * @property {string} TYPE - action type
 * @property {ActionCreator} success - an action that indicates the async method had succeed
 * @property {ActionCreator} failure - an action that indicates the async method has failed
 * @property {ActionCreator} progress - an action that indicates a progress in the async method has been made
 * @property {ActionCreator} cancel - an action that indicates the async method has been canceled
 *
 * @param baseName
 * @param [argsMapper]
 * @param [options]
 * @returns {AsyncActionCreator}
 */

export default function makeAsyncActionCreator(baseName, argsMapper, options) {
  options = getOptions({
    argsMapper: argsMapper,
    options: options
  });
  var actionCreator = makeActionCreator("".concat(baseName).concat(ACTION_ASYNC_REQUEST_SUFFIX), options);
  actionCreator[ACTION_ASYNC_SUCCESS_METHOD] = makeActionCreator("".concat(baseName).concat(ACTION_ASYNC_SUCCESS_SUFFIX), trivialArgsMapper, options);
  actionCreator[ACTION_ASYNC_FAILURE_METHOD] = makeActionCreator("".concat(baseName).concat(ACTION_ASYNC_FAILURE_SUFFIX), trivialArgsMapper, options);
  actionCreator[ACTION_ASYNC_PROGRESS_METHOD] = makeActionCreator("".concat(baseName).concat(ACTION_ASYNC_PROGRESS_SUFFIX), trivialArgsMapper, options);
  actionCreator[ACTION_ASYNC_CANCEL_METHOD] = makeActionCreator("".concat(baseName).concat(ACTION_ASYNC_CANCEL_SUFFIX), trivialArgsMapper, options);
  return actionCreator;
}

makeAsyncActionCreator.withDefaults = function (_ref) {
  var _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? '' : _ref$prefix,
      defaultMeta = _ref.defaultMeta;
  return function (baseName, argsMapper, options) {
    options = Object.assign({}, {
      prefix: prefix,
      defaultMeta: defaultMeta
    }, options);
    return makeAsyncActionCreator(baseName, argsMapper, options);
  };
};